import { FC } from 'react';
import { PlaygroundSvgIconProps } from '@utmb/features/races/races-list/playgrounds/PlaygroundIcon';

const HikingTrailIcon: FC<PlaygroundSvgIconProps> = ({ color }) => {
    return (
        <>
            <style jsx>{`
                .cls-1 {
                    fill: ${color};
                }
                .cls-2 {
                    fill: none;
                    stroke: ${color};
                    stroke-miterlimit: 10;
                    stroke-width: 2px;
                }
            `}</style>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.27 52.97" width="34" height="34">
                <polyline
                    className="cls-1"
                    points="4.22 27.07 4.22 22.56 6.14 24.48 7.09 23.53 4.22 20.66 4.22 18.52 6.14 20.45 7.09 19.5 4.22 16.62 4.22 14.49 6.14 16.41 7.09 15.46 3.55 11.92 0 15.46 0.95 16.41 2.87 14.49 2.87 16.62 0 19.5 0.95 20.45 2.87 18.52 2.87 20.66 0 23.53 0.95 24.48 2.87 22.56 2.87 28.52 2.87 28.52"
                />
                <polyline
                    className="cls-1"
                    points="37.4 49.51 37.4 49.51 37.4 45 39.32 46.92 40.27 45.97 37.4 43.1 37.4 40.97 39.32 42.89 40.27 41.94 37.4 39.07 37.4 36.93 39.32 38.86 40.27 37.91 36.73 34.36 33.18 37.91 34.13 38.86 36.05 36.93 36.05 39.07 33.18 41.94 34.13 42.89 36.05 40.97 36.05 43.1 33.18 45.97 34.13 46.92 36.05 45 36.05 50.96 36.05 50.96"
                />
                <path className="cls-2" d="M11.64,53c0-9.33-5.68-10.26-5-20.1s9.45-6.71,10.09-16.27C17.48,4.84,11.22.84,11.22.84" />
                <path className="cls-2" d="M27.78,53c0-9.33-5.68-10.26-5-20.1s9.45-6.71,10.09-16.27C33.62,4.84,27.36.84,27.36.84" />
            </svg>
        </>
    );
};

export default HikingTrailIcon;
